"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkHealth = exports.IndexedCoreSubgraphClient = exports.IndexedStakingSubgraphClient = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const apollo_client_1 = require("apollo-client");
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const apollo_link_http_1 = require("apollo-link-http");
const node_fetch_1 = __importDefault(require("node-fetch"));
var client_1 = require("./staking/client");
Object.defineProperty(exports, "IndexedStakingSubgraphClient", { enumerable: true, get: function () { return __importDefault(client_1).default; } });
var client_2 = require("./core/client");
Object.defineProperty(exports, "IndexedCoreSubgraphClient", { enumerable: true, get: function () { return __importDefault(client_2).default; } });
const HEALTH_QUERY = graphql_tag_1.default `
query health($subgraphName: String!) {
  indexingStatusForCurrentVersion(subgraphName: $subgraphName) {
    synced
    health
    fatalError {
      message
      block {
        number
        hash
      }
      handler
    }
    chains {
      chainHeadBlock {
        number
      }
      latestBlock {
        number
      }
    }
  }
}
`;
function checkHealth(subgraphName) {
    return __awaiter(this, void 0, void 0, function* () {
        const client = new apollo_client_1.ApolloClient({
            link: new apollo_link_http_1.HttpLink({ uri: 'https://api.thegraph.com/index-node/graphql', fetch: node_fetch_1.default }),
            cache: new apollo_cache_inmemory_1.InMemoryCache(),
            shouldBatch: true,
        });
        const result = yield client.query({
            query: HEALTH_QUERY,
            variables: { subgraphName },
            fetchPolicy: 'cache-first'
        });
        return result;
    });
}
exports.checkHealth = checkHealth;
